import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import * as userActions from '../actions';
import { map, exhaustMap, catchError, mergeMap, tap } from 'rxjs/operators';
import { UsersService } from '../../users.service';

@Injectable()
export class UserEffect {
  constructor(private actions$: Actions, private userService: UsersService) {}

  getByIdUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.getUserById),
      exhaustMap((action) =>
        this.userService.getByID(action.id).pipe(
          map((response) => userActions.getUserByIdSuccess({ data: response })),
          catchError((error: any) => of(userActions.getUserByIdFailure(error)))
        )
      )
    )
  );

  updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.updateUser),
      exhaustMap((action) =>
        this.userService.update(action.data).pipe(
          map((response) => userActions.updateUserSuccess({ data: response })),
          catchError((error: any) => of(userActions.updateUserFailure(error)))
        )
      )
    )
  );
}
